import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/react"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { cn } from "../lib/utils"
import { useRef, useEffect } from "react"

function SideBarCollapsible({ token, title, links = [], setSideBarOpen }) {
  const location = useLocation()
  const shouldBeOpen = location.pathname.includes(token)
  const panelRef = useRef(null)

  const navigate = useNavigate()

  const handleClick = () => {
    if (!location.pathname.includes(token)) {
      navigate(
        links && links[0]
          ? (links[0].path ?? `/plan/${token}/activities`)
          : `/plan/${token}/activities`,
      )
    }
  }

  const handleLinkClick = () => {
    const isMobile = window.matchMedia("(max-width: 767px)").matches
    if (isMobile && setSideBarOpen) {
      setSideBarOpen(false)
    }
  }

  return (
    <Disclosure as="div" key={`${token}-${shouldBeOpen}`} defaultOpen={shouldBeOpen}>
      {({ open }) => {
        // Scroll into view when the panel opens
        useEffect(() => {
          if (open && panelRef.current) {
            // Use a timeout to ensure the panel has fully expanded
            setTimeout(() => {
              panelRef.current?.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
              })
            }, 100)
          }
        }, [open])

        return (
          <>
            <DisclosureButton
              className={cn(
                "group flex w-full items-center justify-between border-t bg-white px-4 py-4 text-brand hover:bg-gray-50",
                shouldBeOpen && !open ? "text-brandSecondary" : "hover:text-brand",
              )}
              onClick={handleClick}
            >
              <span className="text-left text-sm font-bold uppercase">{title}</span>
              <i
                className={cn(
                  "fa-solid fa-chevron-down text-lg transition-transform duration-200",
                  open ? "rotate-180" : "",
                )}
              ></i>
            </DisclosureButton>
            <DisclosurePanel ref={panelRef} className="bg-transparent">
              {links.map((link, index) => {
                const isActive = location.pathname.includes(link.path)
                return (
                  <Link
                    key={index}
                    to={link.path}
                    onClick={handleLinkClick}
                    className={cn(
                      "block px-4 py-2 text-right text-sm font-bold transition-colors",
                      isActive ? "text-brandSecondary" : "text-brand hover:text-brandSecondary",
                    )}
                  >
                    {link.label}
                  </Link>
                )
              })}
            </DisclosurePanel>
          </>
        )
      }}
    </Disclosure>
  )
}

export default SideBarCollapsible
